import { defaultTaskTableFields } from '@tasks/tasks.constants';
import { TaskList, TaskListTemplate, TaskView } from '@tasks/tasks.types';
import { cloneDeep } from 'lodash-es';

export namespace TaskViewUtils {
  export const fromTaskList = (taskList: TaskList): TaskView => {
    return { ...taskList, type: 'TaskList' };
  };

  export const fromTemplate = (template: TaskListTemplate, templateId: number): TaskView => {
    return {
      ...template,
      ...template.task_list,
      type: 'TaskListTemplate',
      task_list_template_id: templateId,
    };
  };

  export const fromSavedView = (view: TaskView): TaskView => {
    const taskView = cloneDeep(view);
    if (typeof taskView.definition === 'string') {
      taskView.definition = JSON.parse(taskView.definition || '{}');
    }

    if (taskView.definition.fields) {
      taskView.definition.table.fields = renameIdFieldsToDisplayFields(taskView.definition.fields);
    } else {
      const sourceFields = taskView.definition.table.fields || defaultTaskTableFields;
      taskView.definition.fields = renameIdFieldsToDisplayFields(sourceFields);
      taskView.definition.table.fields = renameIdFieldsToDisplayFields(sourceFields);
    }

    if (!taskView.definition.filters) {
      taskView.definition.filters = taskView.saved_filter.filters;
    }

    return taskView;
  };

  export const toSavedViewPayload = (view: TaskView): TaskView => {
    const table = {
      ...(view.definition?.table ?? {}),
      fields: view.definition.fields,
      groupBy: view.definition?.table?.groupBy,
    };
    const definitionPayload = { table };
    const savedFilter = {
      ...view.saved_filter!,
      filters: view.definition.filters,
    };

    return {
      ...view,
      definition: JSON.stringify(definitionPayload),
      saved_filter: savedFilter,
    };
  };

  const renameIdFieldsToDisplayFields = (fields: unknown[]): unknown[] => {
    return fields.map((field) => {
      if (field === 'project_id') {
        return 'project_title';
      }
      if (field === 'property_id') {
        return 'property_name';
      }
      return field;
    });
  };
}
